<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">帮助管理</div>
          <span class="m-title-s">对帮助内容进行新增、编辑等操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>帮助内容列表
          </div>
          <div class="m-table-btn">
            <el-button @click="openPopup" type="primary" size="">新增帮助内容</el-button>
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" row-key="id" border :tree-props="{children: 'children'}">
          <el-table-column prop="title" label="报告名称" width="300"></el-table-column>
          <el-table-column prop="sort" label="排序" align="center" width="60"></el-table-column>
          <el-table-column prop="createDate" label="创建时间" width="110" align="center"></el-table-column>
          <el-table-column prop="updateDate" label="修改时间" width="110" align="center"></el-table-column>
          <el-table-column prop="remarks" label="备注"></el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click="openForm(scope.row)" plain>编辑</el-button>
              <el-button v-if="scope.row.id.length > 1" type="danger" size="small" @click="thisDel(scope.row.id, scope.row.title)" plain>删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :title="openText" :visible.sync="openState" @close='closeDialog' width="650px" center :close-on-click-modal="false">
      <div class="m-open-container">
        <div class="zs-open-body-ov">
          <el-form :model="form" :rules="rules" ref="form" label-width="125px">
            <el-form-item label="上级菜单: " prop="parentName">
              <el-input v-model="form.parentName" :id="form.parentId" placeholder="点击右侧按钮" disabled>
                <el-button type="primary" slot="append"  @click="tree = true">选择上级菜单</el-button>
              </el-input>
            </el-form-item>
            <el-form-item label="帮助标题: " prop="title">
              <el-input v-model="form.title" placeholder="输入帮助标题"></el-input>
            </el-form-item>
            <el-form-item label="帮助内容: " prop="content">
              <el-input v-model="form.content" type="textarea" :rows="4" placeholder="输入帮助内容"></el-input>
            </el-form-item>
            <el-form-item label="排序: " prop="sort">
              <el-input v-model="form.sort" placeholder="输入排序"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;" v-loading="formLoading">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
      <!-- 选择树 -->
      <el-dialog width="600px" title="请选择上级菜单" :visible.sync="tree" center append-to-body>
        <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
        <el-tree class="filter-tree" :data="dataListOpt" :props="defaultProps" node-key="id" default-expand-all :filter-node-method="filterNode">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span>
              <el-button type="text" size="mini" :name="node.label" :value="data.id" @click="selectMenu">选择</el-button>
            </span>
          </span>
        </el-tree>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'appHelp',
  data () {
    return {
      openText: '新增',
      openState: false,
      formLoading: false,
      isLoading: true,
      list: [],
      form: {
        id: '',
        title: '',
        parentName: '',
        parentId: '',
        content: '',
        sort: ''
      },
      tree: false,
      filterText: '',
      dataListOpt: [],
      defaultProps: {
        children: 'children',
        label: 'title'
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    selectMenu (e) {
      if (this.form.id === e.target.parentElement.value) {
        this.$message.error('选项自身不可做父级')
        return
      }
      this.tree = false
      this.form.parentName = e.target.parentElement.name
      this.form.parentId = e.target.parentElement.value
    },
    filterNode (value, data) {
      if (!value) return true
      return data.title.indexOf(value) !== -1
    },
    closeDialog: function () {
      this.form = {
        id: '',
        title: '',
        parentName: '',
        parentId: '',
        content: '',
        sort: ''
      }
      this.openText = '新增'
      this.openState = false
      this.formLoading = false
    },
    openPopup () {
      this.openState = true
    },
    submit () {
      let _this = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          _this.formLoading = true
          this.$axios.post('/appHelp/save', _this.form)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.listData()
                _this.openState = false
                _this.formLoading = false
              } else {
                _this.$message.error(res.msg)
                _this.formLoading = false
              }
            })
        } else {
          return false
        }
      })
    },
    thisDel (id) {
      let _this = this
      this.$messageBox.confirm('此操作将永久删除当前项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$axios.post('/appHelp/del', {id: id})
          .then((res) => {
            if (res.status === 200) {
              _this.$message.success(res.msg)
              _this.listData()
            } else {
              _this.$message.error(res.msg)
            }
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    openForm (row) {
      this.openText = '编辑'
      this.form = row
      this.openState = true
    },
    // 管理员列表
    listData () {
      let _this = this
      this.isLoading = true
      _this.list = []
      this.$axios.post('/appHelp/list')
        .then((res) => {
          _this.list = res.data[0].children
          _this.dataListOpt = res.data
          _this.isLoading = false
        })
    }
  },
  mounted () {
    this.listData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/platform/AppHelp.vue